import { navigateToUrl, registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";
import microfrontendLayout from "./microfrontend-layout.html";
import { applications } from "./helpers/route-configs";
import { validateToken } from "./helpers/validate-token";
import { loadAppConfig } from "./loadConfig";

loadAppConfig().then(async () => {
  //@ts-ignore
  const { auth$, isKeycloakRoute } = await import("@bsp/auth");

  let authenticated = false;
  let pathIntent = "";

  const routes = constructRoutes(microfrontendLayout);

  // const applications = constructApplications({
  //   routes,
  //   loadApp({ name }) {
  //     return System.import(name);
  //   },
  // });

  const layoutEngine = constructLayoutEngine({ routes, applications });

  applications.forEach(registerApplication);
  layoutEngine.activate();

  auth$.subscribe(({ sessionToken }) => {
    authenticated = validateToken(sessionToken);

    applications.forEach((app) => {
      app.customProps = { authenticated };
    });

    if (!isKeycloakRoute()) {
      if (
        (!authenticated && window.location.pathname === "/") ||
        window.location.pathname === "/landing"
      ) {
        navigateToUrl("/landing");
        return;
      }

      if (!authenticated && window.location.pathname !== "/login") {
        pathIntent = window.location.pathname;
        navigateToUrl("/login");
        return;
      }

      if (
        authenticated &&
        window.location.pathname === "/login" &&
        localStorage.getItem("sessionToken")
      ) {
        navigateToUrl(
          pathIntent !== "" && pathIntent !== "/" ? pathIntent : "/analise"
        );
        return;
      }
    }
  });

  start();
});
